import { useQuery } from '@tanstack/react-query'
import { OpalApiResponseDocument, OpalApiRequestParams } from '../../../schema'
import { moments } from '../../../v3/moments'
import { globalQueryKeys } from '../../queryKeys'

type MomentQueryParams = OpalApiRequestParams<'ReadMomentV3'>['query']
type ResponseDocument = OpalApiResponseDocument<'ReadMomentV3', 200>
type UseGetMomentOptions<T = ResponseDocument> = {
  momentId?: string
  select?: (data: ResponseDocument) => T
  query: MomentQueryParams
  /**
   * @note Defaults to whatever the query client is using; we default clients to `true`
   */
  useErrorBoundary?: boolean
}

export const useReadMoment = <T = ResponseDocument>({
  momentId = '',
  select,
  query,
  useErrorBoundary,
}: UseGetMomentOptions<T>) => {
  return useQuery({
    enabled: Boolean(momentId),
    queryKey: globalQueryKeys.momentById(momentId, query),
    queryFn: () =>
      moments.readSingle({
        path: { moment_id: momentId },
        query,
      }),
    select,
    ...(useErrorBoundary === undefined ? {} : { useErrorBoundary }),
  })
}
